import { jsx as _jsx } from "react/jsx-runtime";
import { AnnotationOutline, BoundingBox, LineweightMedium } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import classNames from "classnames";
import { memo, useCallback } from "react";
import { useAnnotationV2Context } from "~/components/AnnotationsV2/providers/AnnotationV2Provider";
const toolIcons = {
    point: AnnotationOutline,
    box: BoundingBox,
    pencil: LineweightMedium
};
export const AnnotationToolSelector = /*#__PURE__*/ memo(()=>{
    const { selectedTool, setSelectedTool } = useAnnotationV2Context();
    const handleToolSelect = useCallback((tool)=>{
        setSelectedTool(tool);
    }, [
        setSelectedTool
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center gap-1",
        children: [
            "point",
            "box",
            "pencil"
        ].map((tool)=>{
            const IconComponent = toolIcons[tool];
            const isSelected = selectedTool === tool;
            return /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                size: "small",
                label: "".concat(tool.charAt(0).toUpperCase() + tool.slice(1), " annotation"),
                className: classNames("text-grey-11 hover:text-grey-12", isSelected && "bg-teal-9 text-white hover:bg-teal-9 hover:text-white"),
                onClick: ()=>handleToolSelect(tool),
                children: /*#__PURE__*/ _jsx(IconComponent, {
                    className: "size-4"
                })
            }, tool);
        })
    });
});
AnnotationToolSelector.displayName = "AnnotationToolSelector";
